import React, {Dispatch, SetStateAction, useState} from 'react';
import headerGraphic from '../../Assets/head.svg'
import styled from "styled-components";
import {FaBars, FaInstagram,} from "react-icons/fa";
import {ImCross} from "react-icons/im";
import {Navigation} from "../../Types/navigationType";

interface Props {
    setPage: Dispatch<SetStateAction<Navigation>>;
    setEng: Dispatch<SetStateAction<boolean>>;
    isEng: boolean;
    register: boolean;
}

const Navbar = (props: Props) => {

    const {setPage, isEng, setEng} = props;
    const [menu, toggleMenu] = useState(false);

    return (
        <Wrapper>
            <NavbarDiv>
                <BurgerDiv onClick={()=>toggleMenu(!menu)}>
                    {!menu ?
                        ( <FaBars size={30} fill={"#E44432"}/> ):
                        (<ImCross size={30} fill={"#FFFFFF"}/> )}
                </BurgerDiv>
                {menu && <Sidebar>
                    <ul onClick={()=>toggleMenu(false)}>
                        <li onClick={()=>setPage(Navigation.HOME)}>{isEng ? 'Competition' : 'Konkurs'}</li>
                        <li onClick={()=>setPage(Navigation.RULES)}>{isEng ? 'Rules' : 'Regulamin'}</li>
                        <li onClick={()=>setPage(Navigation.JURY)}>Jury</li>
                        <li onClick={()=>setPage(Navigation.VOTING)}>{isEng ? 'Winners' : 'Laureaci'}</li>
                    </ul>
                    <span> <FaInstagram size={30} fill={"#F6A729"}/></span>
                </Sidebar>}

                <NavElements>
                    <ul>
                        <li onClick={()=>setPage(Navigation.HOME)}>{isEng ? 'Competition' : 'Konkurs'}</li>
                        <li onClick={()=>setPage(Navigation.RULES)}>{isEng ? 'Rules' : 'Regulamin'}</li>
                        <li onClick={()=>setPage(Navigation.JURY)}>Jury</li>
                        <li onClick={()=>setPage(Navigation.VOTING)}>{isEng ? 'Winners' : 'Laureaci'}</li>
                    </ul>
                </NavElements>
                <RightNav>
                    <span> <FaInstagram size={30} fill={"#F6A729"}/></span>
                    <LangToggle onClick={()=>{setEng(!isEng)}} style={{backgroundColor: (isEng ? '#F6A729': '#4169e1')}}>{isEng? 'Polski' : 'English'}</LangToggle>
                </RightNav>
            </NavbarDiv>
            <img src={headerGraphic} alt={'Graphic Header'}/>
        </Wrapper>
    )
}

export default Navbar


const Wrapper = styled.div`
img{
  position: absolute;
  top: -10px;
  z-index: -1;
  
  @media (max-width: 1200px){
    top: 0px;
  }

  @media (max-width: 1000px){
    top: 10px;
  }

  @media (max-width: 800px){
    top: 20px;
  }

  @media (max-width: 600px){
    top: 30px;
  }

  @media (max-width: 400px){
    top: 40px;
  }
}
`
const Sidebar = styled.div`
  position: absolute;
  top: 0;
  height: auto;
  width: 100vw;
  padding: 20px 0;
  text-align: center;
  background-color: #E44432;
  z-index: 2;

  ul {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    list-style: none;
    align-items: center;  
  }

  li {
    color: white;
    font-weight: 600;
    padding: 15px;
    width: 100px;
    text-align: center;
    margin-right: 30px;
  }
  
  li:hover{
    background-color: #88281c;
  }
`

const NavbarDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

`

const BurgerDiv = styled.div`
  display: none;
  padding-left: 30px;
  z-index: 4;
  @media (max-width: 1200px) {
    display: block
  }
`
const RightNav = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;

  span {
    margin-right: 25px;
  }

  span:hover {
    opacity: 0.7;
  }
`
const NavElements = styled.div`
  padding: 20px 0px 20px 50px;
  width: 60%;
  @media (max-width: 1200px) {
    display: none;
  }


  ul {
    display: flex;
    justify-content: space-between;
    list-style-type: none;
  }

  li {
    background-color: #E44432;
    color: white;
    font-weight: 600;
    padding: 15px;
    width: 100px;
    border-radius: 25px;
    text-align: center;
    margin-right: 30px;
  }

  li:hover {
    background-color: #88281c;
  }

  .nav-elements ul li:not(:last-child) {
    margin-right: 60px;
  }

  .nav-elements ul a {
    font-size: 16px;
    font-weight: 400;
    color: #2f234f;
    text-decoration: none;
  }

  .nav-elements ul a.active {
    color: #574c4c;
    font-weight: 500;
    position: relative;
  }

  .nav-elements ul a.active::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #574c4c;
  }`


const LangToggle = styled.div`
  color: white;
  font-weight: 600;
  font-size: 12px;
  padding: 10px;
  border-radius: 25px;
  text-align: center;
  margin-right: 30px;
  
  :hover{
    opacity: 0.7;
  }
`


